
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cartoon-generator",
      function () {
        return require("private-next-pages/cartoon-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cartoon-generator"])
      });
    }
  